module.exports = __webpack_public_path__ + "img/memo.38ccc354.svg";